import { render, staticRenderFns } from "./_EditOrderNumberDialog.vue?vue&type=template&id=1600b138&scoped=true&"
import script from "./_EditOrderNumberDialog.vue?vue&type=script&lang=js&"
export * from "./_EditOrderNumberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1600b138",
  null
  
)

export default component.exports